import type { ContentListParams } from '@opus/types';

/** TanStack Query key factory — one shape everywhere (brief 003-000-001 §3.2). */
export const queryKeys = {
  navigation: (identifier: string) => ['navigation', identifier] as const,
  settings: () => ['settings'] as const,
  theme: () => ['theme'] as const,
  content: (type: string, params?: ContentListParams) => ['content', type, params ?? {}] as const,
  contentItem: (type: string, slug: string) => ['content', type, 'slug', slug] as const,
  search: (q: string) => ['search', q] as const,
};

export const STALE = {
  content: 60_000,
  navigation: 5 * 60_000,
  settings: 10 * 60_000,
} as const;
